export default __webpack_public_path__ + "static/roadmap_tablet-f7e65d4a5de86e3982a86d941c6cf609.png";